import React from 'react';
import ScrollToTop from "../../components/utils/ScrollToTop";
import useWindowSize from "../../components/utils/useWindowSize";
import './index.scss'
import Header from "../../components/header";
import Intermediate from "../../components/Intermediate";
const IntermediatePage = () => {
    const {height , width} = useWindowSize()
    ScrollToTop()
    window.addEventListener('resize', () => {
        // получаем текущее значение высоты
        let vh = window.innerHeight * 0.01;
        let vw = window.innerWidth * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        document.documentElement.style.setProperty('--vw', `${vw}px`);
    });
    return (
        <div className={'IntermediatePageContainer'} style={{maxHeight: height +'px', maxWidth:width + 'px'}}>
            <Header/>
            <Intermediate/>
        </div>
    );
};

export default IntermediatePage;
